// Module
var code = `<div class="py-1 max-size scroll__container" custom-scroll to-top="1"> <div ng-include="::resultTemplates[gameVersion]"></div> <div class="alert alert-info fit-content" ng-if="noResults"> {{ 'main.no_results_found' | translate }} </div> </div> `;
// Exports
var _module_exports =code;;
var path = '/games/lucky_six/results/lucky_six.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;